export * from './sap-storage-view.component'